<script lang="ts">
	// import { RepositoryListData } from '../models/state';
	import { getTokenStorage } from '../utils/localStorage';
	import Navbar from '../components/Navbar.svelte';
	import { onMount } from 'svelte';
	import { appStore } from '../stores/appStore';
	// import type { AppApiClient } from '../api_contracts/app.client';
  import { AppApiClient } from "../api_contracts/app.client";
  import { RepositoryInfo } from '../api_contracts/app';

	// let isAuthenticated = $state(false);

    // // Mock data
	// const repositories = [
	// 	{
	// 		name: 'koru-website',
	// 		description: 'Marketing website for Koru platform',
	// 		visibility: 'public',
	// 		language: 'TypeScript',
	// 		languageColor: '#3178c6',
	// 		stars: 42,
	// 		updatedAt: '2 hours ago',
    //         forks: 12
	// 	},
	// 	{
	// 		name: 'api-gateway',
	// 		description: 'Microservices API gateway with rate limiting',
	// 		visibility: 'private',
	// 		language: 'Go',
	// 		languageColor: '#00ADD8',
	// 		stars: 18,
	// 		updatedAt: '5 hours ago',
    //         forks: 3
	// 	},
	// 	{
	// 		name: 'mobile-app',
	// 		description: 'React Native mobile application',
	// 		visibility: 'private',
	// 		language: 'JavaScript',
	// 		languageColor: '#f1e05a',
	// 		stars: 7,
	// 		updatedAt: '1 day ago',
    //         forks: 0
	// 	},
	// 	{
	// 		name: 'ml-pipeline',
	// 		description: 'Machine learning data pipeline',
	// 		visibility: 'public',
	// 		language: 'Python',
	// 		languageColor: '#3572A5',
	// 		stars: 91,
	// 		updatedAt: '3 days ago',
    //         forks: 24
	// 	},
    //     {
	// 		name: 'design-system',
	// 		description: 'Shared UI components and design tokens',
	// 		visibility: 'public',
	// 		language: 'CSS',
	// 		languageColor: '#563d7c',
	// 		stars: 35,
	// 		updatedAt: '5 days ago',
    //         forks: 8
	// 	},
    //     {
	// 		name: 'auth-service',
	// 		description: 'Authentication and authorization service',
	// 		visibility: 'private',
	// 		language: 'Go',
	// 		languageColor: '#00ADD8',
	// 		stars: 12,
	// 		updatedAt: '1 week ago',
    //         forks: 2
	// 	}
	// ];

	// // Check authentication status
	// $effect(() => {
	// 	const token = getTokenStorage();
	// 	isAuthenticated = !!token;
    //     if (!isAuthenticated) {
    //         window.location.hash = '/login';
    //     }
	// });

   

	let client: AppApiClient | null = $state(null);
	let token: string = $state('');
	let profile: any = $state(null);
	let allRepositories: RepositoryInfo[] = $state([]);
	let repositories: RepositoryInfo[] = $state([]);
	let loading: boolean = $state(true);
	let error: string = $state('');
	let currentPage: number = $state(1);
	let itemsPerPage: number = $state(10);
	let totalPages: number = $derived(Math.ceil(allRepositories.length / itemsPerPage));

	// Subscribe to store
	appStore.subscribe(state => {
		client = state.client;
		token = state.token;
		profile = state.profile;
	});

	// Helper to format relative time
	function formatRelativeTime(timestamp: Date): string {
		const now = new Date();
		const diff = now.getTime() - timestamp.getTime();
		const seconds = Math.floor(diff / 1000);
		const minutes = Math.floor(seconds / 60);
		const hours = Math.floor(minutes / 60);
		const days = Math.floor(hours / 24);
		const months = Math.floor(days / 30);
		const years = Math.floor(days / 365);

		if (seconds < 60) return 'just now';
		if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
		if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
		if (days < 30) return `${days} day${days === 1 ? '' : 's'} ago`;
		if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`;
		return `${years} year${years === 1 ? '' : 's'} ago`;
	}

	function updateDisplayedRepositories() {
		const startIndex = (currentPage - 1) * itemsPerPage;
		const endIndex = startIndex + itemsPerPage;
		repositories = allRepositories.slice(startIndex, endIndex);
	}

	function goToPage(page: number) {
		if (page >= 1 && page <= totalPages) {
			currentPage = page;
			updateDisplayedRepositories();
		}
	}

	async function fetchRepositories() {
		if (!client || !token) {
			loading = false;
			return;
		}

		try {
			loading = true;
			error = '';

			const result = await client.getUserRepositories({
				token,
				userName: '' // Empty means get current user's repositories
			});

			if (result.response.successFull && result.response.repositories) {
				// Sort by updatedAt descending
				const sortedRepos = [...result.response.repositories].sort((a, b) => {
					const timeA = Number(a.updatedAt?.seconds || 0);
					const timeB = Number(b.updatedAt?.seconds || 0);
					return timeB - timeA;
				});

				allRepositories = sortedRepos
				// .map(repo => ({
				// 	name: repo.name,
				// 	description: repo.description || '',
				// 	visibility: repo.visibility,
				// 	language: repo.primaryLanguage || '',
				// 	languageColor: repo.primaryLanguageColor || '#cccccc',
				// 	stars: repo.starCount,
				// 	forks: repo.forkCount,
				// 	updatedAt: formatRelativeTime(new Date(Number(repo.updatedAt?.seconds || 0) * 1000))
				// }));

				updateDisplayedRepositories();
			} else {
				error = result.response.reason || 'Failed to fetch repositories';
			}
		} catch (e: any) {
			error = e.message || 'Error fetching repositories';
			console.error('Error fetching repositories:', e);
		} finally {
			loading = false;
		}
	}

	onMount(() => {
		// Check if authenticated
		const storedToken = getTokenStorage();
		if (storedToken) {
			fetchRepositories();
		} else {
			loading = false;
		}
	});
</script>

<Navbar />

<div class="min-h-screen bg-gray-50 dark:bg-gray-950 ">
    <!-- Header -->
    <div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div class="flex items-center justify-between">
                <div>
                    <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">Repositories</h1>
                    <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
                        Manage your source code repositories.
                    </p>
                </div>
                <div class="flex space-x-3">
                    <div
                    on:click={() => window.location.hash = '/repositories/new'}
                      
                        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-500 hover:bg-[#A6CE39]   focus:outline-none focus:ring-1 focus:ring-[#5EAED3]"
                    >
                        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 4v16m8-8H4"
                            />
                        </svg>
                        New Repository
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        
        <!-- Search and Filters -->
        <div class="mb-6 flex flex-col sm:flex-row gap-4">
            <div class="relative flex-1">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </div>
                <input
                    type="text"
                    class="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md leading-5 bg-white dark:bg-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-gray-900 dark:text-gray-100"
                    placeholder="Find a repository..."
                />
            </div>
            <div class="flex gap-2">
                <select class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
                    <option>All Types</option>
                    <option>Public</option>
                    <option>Private</option>
                    <option>Sources</option>
                    <option>Forks</option>
                </select>
                 <select class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
                    <option>All Languages</option>
                    <option>TypeScript</option>
                    <option>Go</option>
                    <option>Python</option>
                    <option>JavaScript</option>
                </select>
            </div>
        </div>

        <!-- Repository List -->
        <div class="bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-md border border-gray-200 dark:border-gray-700">
            <ul class="divide-y divide-gray-200 dark:divide-gray-700">
                {#each repositories as repo}
                    <li>
                        <a href="#/users/{profile?.userName}/repositories/{repo.name}" class="block hover:bg-gray-50 dark:hover:bg-gray-700 transition duration-150 ease-in-out">
                            <div class="px-4 py-4 sm:px-6">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <p class="text-lg font-semibold text-indigo-600 dark:text-indigo-400 truncate mr-3">
                                            {repo.name}
                                        </p>
                                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium {repo.visibility === 'public' ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'}">
                                            {repo.visibility}
                                        </span>
                                    </div>
                                    <div class="ml-2 flex-shrink-0 flex">
                                        <p class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300">
                                            Updated {repo.updatedAt}
                                        </p>
                                    </div>
                                </div>
                                <div class="mt-2 sm:flex sm:justify-between">
                                    <div class="sm:flex">
                                        {#if repo.description}
                                            <p class="flex items-center text-sm text-gray-500 dark:text-gray-400 mr-6">
                                                {repo.description}
                                            </p>
                                        {/if}
                                    </div>
                                </div>
                                <div class="mt-2 sm:flex sm:justify-between">
                                    <div class="sm:flex items-center text-sm text-gray-500 dark:text-gray-400">
                                        {#if repo.primaryLanguage}
                                            <div class="flex items-center mr-6">
                                                <span class="w-3 h-3 rounded-full mr-1.5" style="background-color: {repo.primaryLanguageColor}"></span>
                                                {repo.primaryLanguage}
                                            </div>
                                        {/if}
                                        <div class="flex items-center mr-6">
                                             <svg class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                            </svg>
                                            {repo.starCount}
                                        </div>
                                         <div class="flex items-center">
                                            <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" class="octicon octicon-repo-forked mr-2">
    <path d="M5 5.372v.878c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-.878a2.25 2.25 0 1 1 1.5 0v.878a2.25 2.25 0 0 1-2.25 2.25h-1.5v2.128a2.251 2.251 0 1 1-1.5 0V8.5h-1.5A2.25 2.25 0 0 1 3.5 6.25v-.878a2.25 2.25 0 1 1 1.5 0ZM5 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm6.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-3 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"></path>
</svg>
                                            {repo.forkCount}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>
